import React from "react";

import {
  IonHeader,
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
  IonTitle
} from "@ionic/react";

import { arrowBackOutline } from "ionicons/icons";

interface ModalHeaderProps {
  handleClose: (event: any) => void;
  title: string;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({ handleClose, title }) => {
  return (
    <IonHeader>
      <IonToolbar>
        <IonButtons slot="start">
          <IonButton onClick={() => handleClose(null)}>
            <IonIcon icon={arrowBackOutline} />
          </IonButton>
        </IonButtons>
        <IonTitle>{title}</IonTitle>
      </IonToolbar>
    </IonHeader>
  );
};

export default ModalHeader;
